import { Building2, Plus, User } from '@carouselgg/nexus/icon'
import { ActionLink } from '../../../components/ActionLink'
import styles from './home.module.css'

/**
 * The three ways onto Carousel — go solo, bring your squad, run the show — for
 * someone with no team, entry or org yet.
 *
 * Signing up solo comes first: like a rec league, most people arrive on their
 * own and want to be put on a team. A team and a club are one idea here — a
 * team is a club with one team — so they are one choice, not two.
 */
export function StartHere({ signedOut = false }: { signedOut?: boolean } = {}) {
  // Signed out, starting something goes through sign-up first: `for` sets the
  // signup pitch, `redirect` carries on to the step afterwards. Browsing
  // competitions needs no account, so that one goes straight there.
  const via = (path: string, intent?: 'club' | 'league') =>
    signedOut
      ? `/signup?${intent ? `for=${intent}&` : ''}redirect=${encodeURIComponent(path)}`
      : path
  return (
    <section aria-label="Ways to play" className={styles.paths}>
      <div className={styles.path}>
        <span className={styles.pathEyebrow}>On your own</span>
        <h2 className={styles.pathTitle}>Go solo</h2>
        <p className={styles.pathBody}>
          Pick a competition and enter by yourself, like signing up for a rec league. The league puts you on a
          team, or a captain picks you up from the free-agent pool.
        </p>
        <ActionLink to="/compete" className={styles.pathAction}>
          <User size={16} aria-hidden="true" /> Find a competition
        </ActionLink>
      </div>
      <div className={styles.path}>
        <span className={styles.pathEyebrow}>Got friends who play?</span>
        <h2 className={styles.pathTitle}>Bring your squad</h2>
        <p className={styles.pathBody}>
          Name your squad and share one invite link. Add more teams whenever you like and it becomes a club.
        </p>
        <ActionLink to={via('/create-org?type=organization', 'club')} variant="secondary" className={styles.pathAction}>
          <Plus size={16} aria-hidden="true" /> Start your squad
        </ActionLink>
      </div>
      <div className={styles.path}>
        <span className={styles.pathEyebrow}>Organizing events?</span>
        <h2 className={styles.pathTitle}>Run the show</h2>
        <p className={styles.pathBody}>
          Leagues or tournaments, without the spreadsheets. Take sign-ups, place free agents on teams, and let
          Carousel build the schedule and keep the standings.
        </p>
        <ActionLink to={via('/create-org?type=league', 'league')} variant="secondary" className={styles.pathAction}>
          <Building2 size={16} aria-hidden="true" /> Host an event
        </ActionLink>
      </div>
    </section>
  )
}
